<template>
  <div>
    <div>
      <div class="vue-select-container" v-on:click="openDropdown()">
        <div
          class="vue-value-container"
          style="white-space: nowrap;text-overflow: ellipsis;overflow: hidden;"
        >
          <div class="vue-placeholder">
            <span
              v-if="criteriaData.DropDownOptions.length == 0 && criteriaData.search == ''"
            >{{criteriaData.label}}</span>
            <span v-if="criteriaData.search == ''">
              <span v-for="opt in criteriaData.DropDownOptions" :key="opt.Id">{{opt.Option}},</span>
            </span>
          </div>
        </div>
        <div class="vue-input">
          <input class="sear" v-model="criteriaData.search" type="text" />
        </div>
        <span class="arrow">
          <i class="fa fa-caret-down"></i>
        </span>
      </div>
      <div class="vue-dropdown-panel" v-show="criteriaData.showDropdown">
        <div class="vue-dropdown-header">
          <div class="ey-select-all">
            <input
              id="All"
              class="k-checkbox form-control"
              @change="checkAll($event)"
              v-model="criteriaData.All"
              type="checkbox"
            />
            <label class="k-checkbox-label" for="All">Select All</label>
          </div>
        </div>
        <div
          class="vue-dropdown-panel-items"
          style="max-height: 100px !important; padding: 0px 0px !important; margin-left: 16px !important;"
        >
          <div v-for="option in filteredOptions" :key="option.Id">
            <input
              v-bind:id="option.Id"
              @change="check($event)"
              :value="option"
              class="k-checkbox form-control"
              type="checkbox"
              v-model="criteriaData.DropDownOptions"
            />
            <label class="k-checkbox-label" v-bind:for="option.Id">{{option.Option}}</label>
          </div>
        </div>

        <div class="vue-dropdown-footer">
          <div style="padding:0 16px;">{{criteriaData.DropDownOptions.length}} Selected</div>
          <div>
            <button style="width:50%" class="btn btn-secondary" @click.prevent="Cancel">Cancel</button>
            <button style="width:50%" class="btn btn-primary" @click.prevent="SelectedOptions">Ok</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MultiSelect",

  props: {
    dropdownOptions: {},
    criteriaData: Object
  },

  data: function() {
    return {};
  },

   computed: {
    filteredOptions: function() {
      var self = this;
      if (( self.dropdownOptions != undefined) && (self.dropdownOptions.filter != undefined)){
      return self.dropdownOptions.filter(function(cust) {
        return (
          cust.Option.toLowerCase().indexOf(
            self.criteriaData.search.toLowerCase()
          ) >= 0
        );
      });
      } else {
          return {};
      }
    }
  },

  mounted() {
    const self = this;
  },

  methods: {
    SelectedOptions(e) {
      if (e != null && e != undefined) {
        e.preventDefault();
      }
      this.criteriaData.showDropdown = false;
    },

    Cancel(e) {
      if (e != null && e != undefined) {
        e.preventDefault();
      }
      this.criteriaData.DropDownValue = [];
      this.criteriaData.All = false;
      this.criteriaData.showDropdown = false;
    },

    checkAll(e) {
      if (this.criteriaData.All)
        this.criteriaData.DropDownOptions = this.dropdownOptions;
      else this.criteriaData.DropDownOptions = [];
    },

    check(e) {
      if (
        this.criteriaData.DropDownOptions.length == this.dropdownOptions.length
      )
        this.criteriaData.All = true;
      else this.criteriaData.All = false;
    },

    openDropdown() {
      var scrollTop = $(window).scrollTop();
      var topOffset = $(".vue-select-container").offset().top;
      var relativeOffset = topOffset - scrollTop;
      var windowHeight = $(window).height();
      this.criteriaData.showDropdown = true;
      $(".vue-dropdown-panel").width($(".vue-select-container").width() + 30);
      if (relativeOffset > windowHeight / 2) {
        $(".vue-dropdown-panel").addClass("reverse");
      } else {
        $(".vue-dropdown-panel").removeClass("reverse");
      }
    }
  }
};
</script>